<main class="content-certificates">
  <h2 class="title">Tus certificados</h2>
<section>
  <h1 class="no-certificates" *ngIf="!hasCertificates">Completa tus cursos para obtener certificados</h1>
  <app-certificates-card (hasCertificate)="message($event)"></app-certificates-card>
</section>
</main>
